var $nodes, signupDialog, templates, termsHtml;

import $ from 'jquery';

import I18n from 'i18n!registration';

import preventDefault from '../fn/preventDefault';

import registrationErrors from './registrationErrors';

import teacherDialog from 'jst/registration/teacherDialog';

import studentDialog from 'jst/registration/studentDialog';

import parentDialog from 'jst/registration/parentDialog';

import newParentDialog from 'jst/registration/newParentDialog';

import samlDialog from 'jst/registration/samlDialog';

import addPrivacyLinkToDialog from '../util/addPrivacyLinkToDialog';

import htmlEscape from 'str/htmlEscape';

import '../jquery/validate';

import 'jquery.instructure_forms';

import 'jquery.instructure_date_and_time';

$nodes = {};

templates = {
  teacherDialog: teacherDialog,
  studentDialog: studentDialog,
  parentDialog: parentDialog,
  newParentDialog: newParentDialog,
  samlDialog: samlDialog
};

termsHtml = function(arg) {
  var privacy_policy_url, terms_of_use_url;
  terms_of_use_url = arg.terms_of_use_url, privacy_policy_url = arg.privacy_policy_url;
  return I18n.t("teacher_dialog.agree_to_terms_and_pp", "You agree to the *terms of use* and acknowledge the **privacy policy**.", {
    wrappers: ["<a href=\"" + (htmlEscape(terms_of_use_url)) + "\" target=\"_blank\">$1</a>", "<a href=\"" + (htmlEscape(privacy_policy_url)) + "\" target=\"_blank\">$1</a>"]
  });
};

signupDialog = function(id, title, path) {
  var $form, $node, el, html;
  if (path == null) {
    path = null;
  }
  if (!templates[id]) {
    return;
  }
  $node = $nodes[id] != null ? $nodes[id] : $nodes[id] = $('<div />');
  path || (path = "/users");
  html = templates[id]({
    account: ENV.ACCOUNT.registration_settings,
    terms_required: ENV.ACCOUNT.terms_required,
    terms_html: termsHtml(ENV.ACCOUNT),
    path: path
  });
  $node.html(html);
  $node.find('.signup_link').click(preventDefault(function() {
    $node.dialog('close');
    return signupDialog($(this).data('template'), $(this).prop('title'));
  }));
  $form = $node.find('form');
  $form.formSubmit({
    required: (function() {
      var i, len, ref, results;
      ref = $form.find(':input[name]').not('[type=hidden]');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        el = ref[i];
        results.push(el.name);
      }
      return results;
    })(),
    disableWhileLoading: 'spin_on_success',
    errorFormatter: registrationErrors,
    success: (function(_this) {
      return function(data) {
        if (data.destination) {
          return window.location = data.destination;
        } else if (data.course) {
          return window.location = "/courses/" + data.course.course.id + "?registration_success=1";
        } else {
          return window.location = "/?registration_success=1";
        }
      };
    })(this),
    error: (function(_this) {
      return function(data) {
        var error_msg;
        if (data.error) {
          error_msg = data.error.message;
          $("input[name='" + (htmlEscape(data.error.input_name)) + "']").next('.error_message').text(htmlEscape(error_msg));
          return $.screenReaderFlashMessage(error_msg);
        }
      };
    })(this)
  });
  $node.dialog({
    resizable: false,
    title: title,
    width: Math.min(screen.width, 550),
    height: screen.height > 750 ? 'auto' : screen.height,
    open: function() {
      $(this).find('a').eq(0).blur();
      $(this).find(':input').eq(0).focus();
      return typeof signupDialog.afterRender === "function" ? signupDialog.afterRender() : void 0;
    },
    close: function() {
      if (typeof signupDialog.teardown === "function") {
        signupDialog.teardown();
      }
      return $('.error_box').filter(':visible').remove();
    }
  });
  $node.fixDialogButtons();
  if (!ENV.ACCOUNT.terms_required) {
    return addPrivacyLinkToDialog($node);
  }
};

signupDialog.templates = templates;

export default signupDialog;
